import Login from "./components/Login";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
// import '@ionic/react/css/structure.css'; // Remove if nothing is visible
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";
import { setupIonicReact } from "@ionic/react";

import { createGlobalStyle } from "styled-components";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "./components/Context/UserContext";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import Layout from "./components/Layout";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import TyreAxleMaster from "./components/pages/master/TyreAxleMaster";
import VehicleGroup from "./components/pages/master/VehicleGroup";
import InsuranceMaster from "./components/pages/master/InsuranceMaster";
import BankMaster from "./components/pages/master/BankMaster";
import FinanceMaster from "./components/pages/master/FinanceMaster";
import City from "./components/pages/master/City";
import State from "./components/pages/master/State";
import Brand from "./components/pages/master/Brand";
import Division from "./components/pages/master/Division";
// import Store from "./components/pages/master/Store";
import WheelMaster from "./components/pages/master/WheelMaster";
import VehicleTypeMaster from "./components/pages/master/VehicleTypeMaster";
import AddNewVehicle from "./components/pages/master/AddNewVehicle";
import PermitTypeMaster from "./components/pages/master/PermitTypeMaster";
import ItemCategory from "./components/pages/master/ItemCategory";
import ItemSubCategory from "./components/pages/master/ItemSubCategory";
import ItemSubSubCategory from "./components/pages/master/ItemSubSubCategory";
import MaterialType from "./components/pages/master/MaterialType";
import ItemPrefix from "./components/pages/master/ItemPrefix";
import ItemWithBrand from "./components/pages/master/ItemWithBrand";
import ItemWithVendor from "./components/pages/master/ItemWithVendor";
import Unit from "./components/pages/master/Unit";
import Department from "./components/pages/master/Department";
import Designation from "./components/pages/master/Designation";
import NotFoundPage from "./components/pages/NotFoundPage";
import Home from "./components/pages/Home";
import { Toaster } from "react-hot-toast";
import SAC from "./components/pages/master/SAC";
import HSN from "./components/pages/master/HSN";
import Item from "./components/pages/master/Item";
import PartyTest from "./components/pages/master/PartyTest";
import IndentCreate from "./components/pages/purchase/indent/IndentCreate";
import IndentView from "./components/pages/purchase/indent/IndentView";
import UpdateIndent from "./components/pages/purchase/indent/updateIndent/UpdateIndent";
import GenerateEnquiry from "./components/pages/purchase/enquiry/GenerateEnquiry";
import ViewEnquiry from "./components/pages/purchase/enquiry/ViewEnquiry";
import Quotation from "./components/pages/purchase/quotation/Quotation";
import ViewQuotation from "./components/pages/purchase/quotation/ViewQuotation";
import UpdateQuotation from "./components/pages/purchase/quotation/UpdateQuotation";
import CompareQuotation from "./components/pages/purchase/compare/CompareQuotation";
import DirectPOCreate from "./components/pages/purchase/po/direct/DirectPOCreate";
import DirectView from "./components/pages/purchase/po/direct/DirectView";
import DirectUpdate from "./components/pages/purchase/po/direct/directUpdate/DirectUpdate";
import IndentPOCreate from "./components/pages/purchase/po/indent/IndentPOCreate";
import IndentPOView from "./components/pages/purchase/po/indent/IndentPOView";
import GatePass from "./components/pages/purchase/gate-pass/GatePass";
import GatePassInView from "./components/pages/purchase/gate-pass/gpView/GatePassInView";
import PendingIndentView from "./components/pages/purchase/indent/pending/PendingIndentView";
import PendingPOView from "./components/pages/purchase/po/pending/PendingPOView";
import PendingGPView from "./components/pages/purchase/gate-pass/pending/PendingGPView";
import GRNCreate from "./components/pages/purchase/GRN/grn-create/GRNCreate";
import GRNView from "./components/pages/purchase/GRN/grn-view/GRNView";
import PendingGRNView from "./components/pages/purchase/GRN/grn-view/pending/PendingGRNView";
import RGP from "./components/pages/purchase/gate-pass/rgp/RGP";
import PendingRGPView from "./components/pages/purchase/gate-pass/rgp/rgp-view/pending/PendingRGPView";
import RGPView from "./components/pages/purchase/gate-pass/rgp/rgp-view/RGPView";
import PendingNRGPView from "./components/pages/purchase/gate-pass/nrgp/nrgp-view/pending/PendingNRGPView";
import NRGPView from "./components/pages/purchase/gate-pass/nrgp/nrgp-view/NRGPView";
import NRGP from "./components/pages/purchase/gate-pass/nrgp/NRGP";
import CreateRole from "./components/pages/master/user-management/CreateRole";
import CreateUser from "./components/pages/master/user-management/CreateUser";
import CreateUserPermis from "./components/pages/master/user-management/CreateUserPermis";
import { BaseURL } from "./components/Reusable/BaseURL";
import UpdateDirectGp from "./components/pages/purchase/gate-pass/update-direct-in-gatepass/UpdateDirectGp";
import CreateVisitor from "./components/pages/gate-entry/CreateVisitor";
import CreateVisitorView from "./components/pages/gate-entry/CreateVisitorView";

setupIonicReact();

const GlobalStyle = createGlobalStyle`
body{
  background: ${({ darkTheme }) => (darkTheme ? "#212121" : "#ffffff")};
  color: ${(props) => (props.darkTheme ? "#ffff" : "#000000")}
}
`;
function App() {
  const { darkTheme, loginData, allPermiss } = useContext(UserContext);

  return (
    <div
      className="max-w-[2100px] mx-auto"
      // onKeyUp={(e)=> keyboardAction(e)}
    >
      <GlobalStyle darkTheme={darkTheme} />
      <Toaster
        toastOptions={{
          className: "",
          style: {
            border: `1px solid ${darkTheme ? "#333" : "#ddd"}`,
            padding: "4px 16px",
            fontSize: "13px",
            color: `${darkTheme ? "#fffa" : "'#333a"}`,
            background: `${darkTheme ? "#212121" : "#ffffff"}`,
            // backdropFilter: "8px",
            boxShadow: "1px 1px 1px 1px rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          },
        }}
      />

      <Router>
        <Routes>
          {loginData?.token && loginData?.username ? (
            <Route exact path="/" element={<Layout />}>
              <Route index element={<Home />} />
              {/* <Route path="/master/store" element={<Store />} /> */}

              {/* {(allPermiss?.includes("master-division-create") ||
                allPermiss?.includes("master-division-view")) && ( */}
              <Route path="/master/division" element={<Division />} />
              {/* )} */}

              {/* {(allPermiss?.includes("master-brand-create") ||
                allPermiss?.includes("master-brand-view")) && ( */}
              <Route path="/master/company" element={<Brand />} />
              {/* )} */}

              {/* {(allPermiss?.includes("master-gst-hsn-create") ||
                allPermiss?.includes("master-gst-hsn-view")) && ( */}
              <Route path="/master/hsn" element={<HSN />} />
              {/* )} */}

              {/* {(allPermiss?.includes("master-gst-sac-create") ||
                allPermiss?.includes("master-gst-sac-view")) && ( */}
              <Route path="/master/sac" element={<SAC />} />
              {/* )} */}

              {/* {(allPermiss?.includes("master-state-create") ||
                allPermiss?.includes("master-state-view")) && ( */}
              <Route path="/master/state" element={<State />} />
              {/* )} */}

              <Route path="/master/city" element={<City />} />

              {/* <Route
                path="/master/finance-master"
                element={<FinanceMaster />}
              />
              <Route path="/master/bank-master" element={<BankMaster />} />
              <Route
                path="/master/insurance-master"
                element={<InsuranceMaster />}
              /> */}

              {/* <Route path="/master/vehicle-group" element={<VehicleGroup />} />
              <Route
                path="/master/axle-position"
                element={<TyreAxleMaster />}
              />
              <Route path="/master/wheel" element={<WheelMaster />} />
              <Route
                path="/master/vehicle-type-master"
                element={<VehicleTypeMaster />}
              />
              <Route
                path="/master/add-new-vehicle"
                element={<AddNewVehicle />}
              />
              <Route
                path="/master/permit-type-master"
                element={<PermitTypeMaster />}
              /> */}

              <Route path="/master/item-category" element={<ItemCategory />} />
              {/* <Route
                path="/master/item-sub-category"
                element={<ItemSubCategory />}
              />
              <Route
                path="/master/item-sub-sub-category"
                element={<ItemSubSubCategory />}
              /> */}

              {/* HIDE FROM CLIENT REQUI.======== */}
              {/* <Route path="/master/material-type" element={<MaterialType />} /> */}

              {/* <Route path="/master/item-prefix" element={<ItemPrefix />} /> */}

              <Route path="/master/item" element={<Item />} />
              <Route
                path="/master/item-with-brand"
                element={<ItemWithBrand />}
              />
              {/* <Route
                path="/master/item-with-vendor"
                element={<ItemWithVendor />}
              /> */}
              <Route path="/master/unit" element={<Unit />} />
              <Route path="/master/supplier" element={<PartyTest />} />
              {/* <Route path="/master/department" element={<Department />} />
              <Route path="/master/designation" element={<Designation />} /> */}

              {/* USER MANAGEMENT  */}
              <Route
                path="/master/user-management/create-role"
                element={<CreateRole />}
              />
              <Route
                path="/master/user-management/create-user"
                element={<CreateUser />}
              />
              <Route
                path="/master/user-management/create-user-permissions"
                element={<CreateUserPermis />}
              />

              {/* PURCHASE===============================  */}
              {/* INDENT  */}
              <Route
                path="/purchase/create-indent"
                element={<IndentCreate />}
              />
              <Route
                path="/purchase/pending-indent-view"
                element={<PendingIndentView />}
              />
              <Route path="/purchase/view-indent" element={<IndentView />} />
              <Route
                path="/purchase/update-indent"
                element={<UpdateIndent />}
              />

              {/* ENQUIRY  */}
              <Route
                path="/purchase/generate-enquiry"
                element={<GenerateEnquiry />}
              />
              <Route path="/purchase/view-enquiry" element={<ViewEnquiry />} />

              {/* QUOTATION  */}
              <Route
                path="/purchase/quotation-enquiry"
                element={<Quotation />}
              />
              <Route
                path="/purchase/view-quotation"
                element={<ViewQuotation />}
              />
              <Route
                path="/purchase/update-quotation"
                element={<UpdateQuotation />}
              />

              {/* COMPARE QUOTATION  */}
              <Route
                path="/purchase/compare-quotation"
                element={<CompareQuotation />}
              />

              {/* PO==== */}
              {/* --------------------------------------direct po  */}
              <Route
                path="/purchase/direct-po-create"
                element={<DirectPOCreate />}
              />
              <Route
                path="/purchase/pending-po-view"
                element={<PendingPOView />}
              />
              <Route path="/purchase/po-view" element={<DirectView />} />
              <Route
                path="/purchase/update-po"
                element={<DirectUpdate />}
              />
              {/* --------------------------------------indent po  */}
              <Route
                path="/purchase/indent-po-create"
                element={<IndentPOCreate />}
              />
              {/* <Route
                path="/purchase/indent-po-view"
                element={<IndentPOView />}
              /> */}

              {/* RGP / NRGP -========= */}
              {/* GATE-PASS: RGP/NRGP  */}
              <Route path="/purchase/rgp" element={<RGP />} />
              <Route
                path="/purchase/pending-rgp"
                element={<PendingRGPView />}
              />
              <Route path="/purchase/view-rgp" element={<RGPView />} />

              <Route path="/purchase/nrgp" element={<NRGP />} />
              <Route
                path="/purchase/pending-nrgp"
                element={<PendingNRGPView />}
              />
              <Route path="/purchase/view-nrgp" element={<NRGPView />} />

              {/* GATE PASS  */}
              <Route path="/purchase/gate-pass" element={<GatePass />} />
              <Route
                path="/purchase/gp/direct-update"
                element={<UpdateDirectGp />}
              />
              <Route
                path="/purchase/pending-gp-view"
                element={<PendingGPView />}
              />
              <Route
                path="/purchase/view-gate-pass"
                element={<GatePassInView />}
              />

              {/* PURCHASE: GRN ========= */}
              <Route path="/purchase/grn-create" element={<GRNCreate />} />
              <Route
                path="/purchase/pending-grn-view"
                element={<PendingGRNView />}
              />
              <Route path="/purchase/view-grn" element={<GRNView />} />

              {/* GATE ENTRY  */}
              <Route
                path="/gate-entry/create-entry-visitors"
                element={<CreateVisitor />}
              />
              <Route
                path="/gate-entry/view-entry-visitors"
                element={<CreateVisitorView />}
              />
            </Route>
          ) : (
            <Route path="/" element={<Login />} />
          )}
          <Route path="/*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
